function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "175.311 247.872 85.875 85.875",
    width: 85.875,
    height: 85.875,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 208.707 262.184 L 208.707 271.726 L 184.853 271.726 L 184.853 324.205 L 237.332 324.205 L 237.332 300.351 L 246.873 300.351 L 246.873 328.976 C 246.873 331.61 244.736 333.747 242.103 333.747 L 180.082 333.747 C 177.444 333.747 175.311 331.61 175.311 328.976 L 175.311 266.955 C 175.311 264.322 177.444 262.184 180.082 262.184 L 208.707 262.184 Z M 261.186 247.872 L 261.186 286.039 L 251.644 286.039 L 251.644 264.155 L 214.465 301.339 L 207.719 294.593 L 244.893 257.414 L 223.019 257.414 L 223.019 247.872 L 261.186 247.872 Z",
    style: {},
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.81eba41c.svg";
export { ForwardRef as ReactComponent };